import { render } from "./CrudModeloVeiculoTrator.vue?vue&type=template&id=34499382"
import script from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script